import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { toolbarButtonSx } from "../../../components/common/toolbarStyles";
import ListIcon from "@mui/icons-material/List";
import { useNavigate } from "react-router-dom";
import { getInitialStudentData } from "../../../modules/common/shared/StudentAPI";
import { StudentAdmissionForm } from "../../admission/components/StudentAdmissionForm";

/** Student → Directory → Add: the admission form in admin mode (all fields editable), with Directory at the top right. */
export default function StudentAddPage() {
  const navigate = useNavigate();
  // Bumped after each successful create; remounting the form resets every field to empty.
  const [formKey, setFormKey] = useState(0);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 2, mr: 2 }}>
      <Box display="flex" alignItems="center" gap={2} sx={{ borderBottom: 1, borderColor: "divider", pb: 1 }}>
        <Typography variant="h6" fontWeight={600}>
          Students
        </Typography>
        <Box flexGrow={1} />
        <Button variant="outlined" size="small" sx={toolbarButtonSx} startIcon={<ListIcon />} onClick={() => navigate("/app/students")}>
          Directory
        </Button>
      </Box>
      <StudentAdmissionForm
        key={formKey}
        mode="ADMIN"
        inputStudent={{ ...getInitialStudentData(), sectionName: "A" }}
        onAdminCreated={() => setFormKey((k) => k + 1)}
      />
    </Box>
  );
}
